import appEnv from 'pages/saml-sso/appEnv';

import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
